var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "role"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('b', [_vm._v("Shipment Details\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('form', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" MPS Number :")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "blue",
      "font-size": "13px"
    }
  }, [_vm._v("\n                    (Note: Use Comma(,) for Multiple AWB Numbers)")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-book'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "AWB",
      "name": "AWB",
      "type": "AWB"
    },
    model: {
      value: (_vm.awbnumber),
      callback: function($$v) {
        _vm.awbnumber = $$v
      },
      expression: "awbnumber"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "id": "AWB"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('AWB')),
      expression: "errors.has('AWB')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("AWB Number is required. ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Mark Damage Zone :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('Multiselect', {
    staticStyle: {
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "name": "newhubs",
      "label": "label",
      "options": _vm.HubZoneData,
      "placeholder": "Enter Zone"
    },
    model: {
      value: (_vm.newhubs),
      callback: function($$v) {
        _vm.newhubs = $$v
      },
      expression: "newhubs"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('newhubs')),
      expression: "errors.has('newhubs')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('newhubs')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Damage Hub :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('Multiselect', {
    staticStyle: {
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "name": "newhubs",
      "label": "label",
      "options": _vm.hubdata,
      "placeholder": "Enter Zone"
    },
    model: {
      value: (_vm.hub),
      callback: function($$v) {
        _vm.hub = $$v
      },
      expression: "hub"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('newhubs')),
      expression: "errors.has('newhubs')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('newhubs')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Pending At:")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('Multiselect', {
    staticStyle: {
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "name": "Pendingat",
      "label": "label",
      "options": _vm.bucketList,
      "placeholder": "Enter Pending At"
    },
    model: {
      value: (_vm.Pendingat),
      callback: function($$v) {
        _vm.Pendingat = $$v
      },
      expression: "Pendingat"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Pendingat')),
      expression: "errors.has('Pendingat')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Pendingat')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.searchData()
      }
    }
  }, [_vm._v(" Search "), _c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("    \n                  Reset")])])])])])], 1), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "ResultGridRegion"
  }, [_c('resultGrid', {
    attrs: {
      "shipmentData": _vm.listUserData,
      "showActionColumn": _vm.showActionColumn
    }
  }), _vm._v(" "), _c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": _vm.pagecount,
      "force-page": _vm.pageValue,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "active": _vm.show,
      "duration": "0.6",
      "spinner": "bar-fade-scale",
      "color": "#FF6700"
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c46fec4","hasScoped":false}!./src/views/components/B2B/B2BSearchPage/B2BSearchPage.component.html
// module id = 598
// module chunks = 1